<ng-container [formGroup]="formGroup">

  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Relationships</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="add()">
        Add a Relationship
      </lds-button>
    </div>
  </div>

  <div formArrayName="relationships">
    <ng-container *ngIf="form.controls.length > 0; else tplNoItems">
      <ng-container *ngFor="let itemForm of form.controls; let i = index">
        <app-inline-item
          *ngIf="!deleted[i]"
          [form]="itemForm"
          [formGroupName]="i"
          [isExpandable]="true"
          [initiallyExpanded]="expandedIndex === i"
          (delete)="remove(i)">
          <inline-summary>
            <div class="row">
              <div class="col-9">
                {{ itemForm.controls.contact.value?.name | summary }}
              </div>
              <div class="col">
                {{ itemForm.controls.type.value }}
              </div>
            </div>
          </inline-summary>
          <inline-content>
            <div class="row">
              <div class="col-9">
                <app-contact-search
                  formControlName="contact"
                  label="Related person"
                  [isRequired]="schema | standardRequirement">
                </app-contact-search>
              </div>

              <div class="col-3">
                <lds-select
                  formControlName="type"
                  label="Related person role"
                  [options]="schema.options | ldsSelectOption"
                  [isRequired]="schema | standardRequirement"
                  [validations]="{
                    required: 'Related person role is required'
                  }">
                </lds-select>
              </div>
            </div>
          </inline-content>
        </app-inline-item>
      </ng-container>
    </ng-container>
    <ng-template #tplNoItems>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      required: 'At least one relationship is required',
      minlength: 'At least one relationship is required'
    }">
  </lds-form-feedback>
</ng-container>
